/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-betting-filter-bar.get-names.ts 
*/
:host {
  box-sizing: border-box;
}
:host * {
  box-sizing: border-box;
}

.ace-betting-filter-bar {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  align-items: center;
  background-color: var(--ace-color-surface-solid--100);
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  container-name: ace-betting-filter-bar;
  container-type: inline-size;
  display: flex;
  flex-direction: row;
  height: 3rem;
  justify-content: flex-start;
  position: relative;
  z-index: 2;
}
@media only screen and (min-width: 595px) {
  .ace-betting-filter-bar {
    justify-content: space-between;
  }
}
.ace-betting-filter-bar--filter-modal-open {
  z-index: 13;
}
.ace-betting-filter-bar--with-filter-button .ace-betting-filter-bar__filters__bar {
  padding-right: calc(var(--ace-semantic-buttons-toggle-button-dimension-button) + var(--ace-semantic-foundation-spacing-gutter-mobile-inner) + var(--ace-primitive-spacing-xx-tight));
}
@media only screen and (min-width: 595px) {
  .ace-betting-filter-bar--grid-variant {
    justify-content: flex-start;
  }
}
.ace-betting-filter-bar__sort__button {
  border-right: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  padding: calc(var(--ace-primitive-spacing-tight) - 0.125rem) var(--ace-primitive-spacing-x-tight);
  position: relative;
  z-index: 2;
}
.ace-betting-filter-bar__sort__button ace-toggle-button {
  --ace-semantic-buttons-toggle-button-radius: 999px;
  --ace-color-brand-tertiary--100: var(--ace-color-surface-solid--200);
}
.ace-betting-filter-bar__sort__bottom-tray {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  padding: 0 var(--ace-primitive-spacing-tight) var(--ace-primitive-spacing-normal);
}
.ace-betting-filter-bar__sort__bottom-tray__items {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-betting-filter-bar__sort__bottom-tray__actions {
  border-top: var(--ace-primitive-border-interactive) var(--ace-color-borders--100);
  display: flex;
  gap: var(--ace-primitive-spacing-normal);
  padding: var(--ace-primitive-spacing-normal);
}
.ace-betting-filter-bar__sort__items {
  border: var(--ace-primitive-border-interactive) var(--ace-color-borders--100);
  border-radius: var(--ace-primitive-radius-x-small);
  display: unset;
  left: var(--ace-semantic-foundation-spacing-padding-ui-medium);
  min-width: 11.25rem;
  padding: unset;
  position: absolute;
  top: 2.5rem;
  z-index: 2;
}
.ace-betting-filter-bar__sort__items__el {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  font-family: var(--ace-type-font-family-input);
  font-size: var(--ace-semantic-form-fields-font-size);
  font-weight: var(--ace-type-font-weight-text);
  letter-spacing: var(--ace-type-letter-spacing-text-regular);
  line-height: var(--ace-semantic-form-fields-line-height);
  align-items: center;
  background: var(--ace-color-surface-solid--100);
  color: var(--ace-color-text-neutral--primary);
  display: flex;
  height: 2.75rem;
  padding: 0 var(--ace-semantic-foundation-spacing-padding-ui-medium);
  position: relative;
  width: 100%;
  z-index: 4;
}
.ace-betting-filter-bar__sort__items__el:first-of-type {
  border-top-left-radius: var(--ace-primitive-radius-x-small);
  border-top-right-radius: var(--ace-primitive-radius-x-small);
}
.ace-betting-filter-bar__sort__items__el:last-of-type {
  border-bottom-left-radius: var(--ace-primitive-radius-x-small);
  border-bottom-right-radius: var(--ace-primitive-radius-x-small);
}
.ace-betting-filter-bar__sort__items__el:hover {
  background: var(--ace-color-surface-solid--200);
  cursor: pointer;
}
.ace-betting-filter-bar__sort__items__el--selected {
  background: var(--ace-color-brand-primary--100);
  color: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-betting-filter-bar__sort__items__el--selected:hover {
  background: var(--ace-color-brand-primary--200);
}
.ace-betting-filter-bar__filters__button {
  background: linear-gradient(90deg, var(--ace-color-overflow-gradient-light-0) 0%, var(--ace-color-overflow-gradient-light-100) 25%, var(--ace-color-overflow-gradient-light-100) 100%);
  padding: 0 var(--ace-semantic-foundation-spacing-gutter-mobile-outer) 0 var(--ace-primitive-spacing-tight);
  position: absolute;
  right: 0;
}
.ace-betting-filter-bar__filters__button ace-toggle-button {
  --ace-semantic-buttons-toggle-button-radius: 999px;
  --ace-color-brand-tertiary--100: var(--ace-color-surface-solid--200);
}
.ace-betting-filter-bar__filters__bar {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: var(--ace-primitive-spacing-xx-tight);
  justify-content: flex-start;
  overflow: scroll;
  padding: var(--ace-primitive-spacing-tight) var(--ace-primitive-spacing-x-tight);
  -webkit-overflow-scrolling: touch; /* iOS */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.ace-betting-filter-bar__filters__bar::-webkit-scrollbar {
  display: none;
  /* WebKit */
  height: 0;
  width: 0;
}
.ace-betting-filter-bar__filters__bar ace-toggle-button {
  --ace-color-brand-tertiary--100: var(--ace-color-surface-solid--200);
}
.ace-betting-filter-bar__filters__bottom-tray {
  display: flex;
  flex-direction: column;
}
.ace-betting-filter-bar__filters__bottom-tray__headline {
  padding: 0 var(--ace-primitive-spacing-tight) var(--ace-primitive-spacing-x-tight);
}
.ace-betting-filter-bar__filters__bottom-tray__items {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  min-height: 40vh;
  overflow: scroll;
}
.ace-betting-filter-bar__filters__bottom-tray__items__el {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  font-size: var(--ace-type-font-size-text-small);
  letter-spacing: var(--ace-type-letter-spacing-text-small);
  line-height: var(--ace-type-line-height-text-small);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  color: var(--ace-color-text-neutral--primary);
  padding: var(--ace-primitive-spacing-x-tight);
  text-align: left;
  width: 100%;
}
.ace-betting-filter-bar__filters__bottom-tray__items__el--selected {
  background: var(--ace-color-brand-primary--100);
  color: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-betting-filter-bar__filters__slots {
  display: flex;
  gap: var(--ace-primitive-spacing-normal);
  justify-content: flex-end;
  padding-right: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
.ace-betting-filter-bar__filters__slots__el {
  display: none;
  width: calc(10.5625rem - 2 * var(--ace-primitive-spacing-x-tight));
}
.ace-betting-filter-bar__filters__slots__el:nth-child(1) {
  display: flex;
}
@container ace-betting-filter-bar (min-width: 32rem) {
  .ace-betting-filter-bar__filters__slots__el:nth-child(2) {
    display: flex;
  }
}
@container ace-betting-filter-bar (min-width: 44.25rem) {
  .ace-betting-filter-bar__filters__slots__el:nth-child(3) {
    display: flex;
  }
}
@container ace-betting-filter-bar (min-width: 50rem) {
  .ace-betting-filter-bar__filters__slots__el:nth-child(4) {
    display: flex;
  }
}